// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3ZDDO","title":"AfterBackImages_title__nnMgz","images":"AfterBackImages_images__1UUbg"};